// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/app/node_modules/umi/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@/components/page-loader/index';

export function getRoutes() {
  const routes = [
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__index' */'@/layouts/index.tsx'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__index' */'@/pages/index.tsx'), loading: LoadingComponent}),
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/auth'), loading: LoadingComponent})]
      },
      {
        "path": "/pdp-v1",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__pdp-v1__index' */'@/pages/pdp-v1/index.tsx'), loading: LoadingComponent}),
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/auth'), loading: LoadingComponent})]
      },
      {
        "path": "/pdp-v2",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__pdp-v2__index' */'@/pages/pdp-v2/index.tsx'), loading: LoadingComponent}),
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/auth'), loading: LoadingComponent})]
      },
      {
        "path": "/travel/information-gathering",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__travel__information-gathering__index' */'@/pages/travel/information-gathering/index.tsx'), loading: LoadingComponent}),
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/auth'), loading: LoadingComponent})]
      },
      {
        "path": "/travel/plan-list",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__travel__plan-list__index' */'@/pages/travel/plan-list/index.tsx'), loading: LoadingComponent}),
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/auth'), loading: LoadingComponent})]
      },
      {
        "path": "/travel/plan-list/compare",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__travel__plan-list__compare__index' */'@/pages/travel/plan-list/compare/index.tsx'), loading: LoadingComponent}),
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/auth'), loading: LoadingComponent})]
      },
      {
        "path": "/travel/plan-details",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__travel__plan-details__index' */'@/pages/travel/plan-details/index.tsx'), loading: LoadingComponent}),
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/auth'), loading: LoadingComponent})]
      },
      {
        "path": "/travel/how-to-claim",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__travel__how-to-claim__index' */'@/pages/travel/how-to-claim/index.tsx'), loading: LoadingComponent}),
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/auth'), loading: LoadingComponent})]
      },
      {
        "path": "/travel/insured",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__travel__insured__index' */'@/pages/travel/insured/index.tsx'), loading: LoadingComponent}),
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/auth'), loading: LoadingComponent})]
      },
      {
        "path": "/travel/summary",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__travel__summary__index' */'@/pages/travel/summary/index.tsx'), loading: LoadingComponent}),
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/auth'), loading: LoadingComponent})]
      },
      {
        "path": "/travel/insurer-pdpa",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__travel__insurer-pdpa__index' */'@/pages/travel/insurer-pdpa/index.tsx'), loading: LoadingComponent}),
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/auth'), loading: LoadingComponent})]
      },
      {
        "path": "/travel/starbucks-coupon",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__travel__starbucks-coupon__index' */'@/pages/travel/starbucks-coupon/index.tsx'), loading: LoadingComponent}),
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/auth'), loading: LoadingComponent})]
      },
      {
        "path": "/terms-and-conditions",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__terms-and-conditions__index' */'@/pages/terms-and-conditions/index.tsx'), loading: LoadingComponent}),
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/auth'), loading: LoadingComponent})]
      },
      {
        "path": "/policy-wording",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__policy-wording__index' */'@/pages/policy-wording/index.tsx'), loading: LoadingComponent}),
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/auth'), loading: LoadingComponent})]
      },
      {
        "path": "/faq",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__faq__index' */'@/pages/faq/index.tsx'), loading: LoadingComponent}),
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/auth'), loading: LoadingComponent})]
      },
      {
        "path": "/how-to-cancel",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__how-to-cancel__index' */'@/pages/how-to-cancel/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/privacy-policies",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__privacy-policies__index' */'@/pages/privacy-policies/index.tsx'), loading: LoadingComponent}),
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/auth'), loading: LoadingComponent})]
      },
      {
        "path": "/consent",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__consent__index' */'@/pages/consent/index.tsx'), loading: LoadingComponent}),
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/auth'), loading: LoadingComponent})]
      },
      {
        "path": "/insured",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__insured__index' */'@/pages/insured/index.tsx'), loading: LoadingComponent}),
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/auth'), loading: LoadingComponent})]
      },
      {
        "path": "/declarations",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__declarations__index' */'@/pages/declarations/index.tsx'), loading: LoadingComponent}),
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/auth'), loading: LoadingComponent})]
      },
      {
        "path": "/summary",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__summary__index' */'@/pages/summary/index.tsx'), loading: LoadingComponent}),
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/auth'), loading: LoadingComponent})]
      },
      {
        "path": "/soi",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__soi__index' */'@/pages/soi/index.tsx'), loading: LoadingComponent}),
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/auth'), loading: LoadingComponent})]
      },
      {
        "path": "/policyholder",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__policyholder__index' */'@/pages/policyholder/index.tsx'), loading: LoadingComponent}),
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/auth'), loading: LoadingComponent})]
      },
      {
        "path": "/error-page",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__error-page__index' */'@/pages/error-page/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/payment-success",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__payment-success__index' */'@/pages/payment-success/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/document-preview",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__document-preview__index' */'@/pages/document-preview/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/maintenance",
        "expect": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__maintenance__index' */'@/pages/maintenance/index.tsx'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/renewal",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__renewal__index' */'@/pages/renewal/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/edit-renewal",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__renewal__editRenewal__index' */'@/pages/renewal/editRenewal/index.tsx'), loading: LoadingComponent})
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
